import React from "react";
import { Database } from "lucide-react";
import { OrderStats, User } from "./types";

interface SystemInfoProps {
  stats: OrderStats | null;
  currentUser?: User;
}

const SystemInfo: React.FC<SystemInfoProps> = ({ stats, currentUser }) => {
  if (currentUser?.role === "country-post-manager") {
    return null; // Only show for non-post office managers
  }

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4 flex items-center">
        <Database className="w-5 h-5 mr-2 text-gray-600" />
        System Information
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <p className="text-sm font-medium text-gray-500">Last Update</p>
          <p className="text-sm text-gray-900">
            {stats?.lastUpdate
              ? new Date(stats.lastUpdate).toLocaleString()
              : "Never"}
          </p>
        </div>
        <div>
          <p className="text-sm font-medium text-gray-500">Shipping Orders</p>
          <p className="text-sm text-gray-900">
            {stats?.shippingOrders || 0} orders in shipping
          </p>
        </div>
        {/* Deep search removed for Serbia-CC */}
      </div>
    </div>
  );
};

export default SystemInfo;
